import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { PageLink as Link } from '../../app/navigation';
import { Header } from './Header';
import { ShieldCheck } from 'lucide-react';
import { brand } from '../../app/brand';
import { BrandLogo } from '../common/BrandLogo';
import './AppShell.css';

export interface AppShellProps {
  children: React.ReactNode;
  activePath?: string;
  onNavigate?: (path: string) => void;
}

export const AppShell: React.FC<AppShellProps> = ({
  children,
  activePath = '/',
  onNavigate,
}) => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);
  return (
    <div className="sedlex-shell">
      <Header activePath={activePath} onNavigate={onNavigate} />
      <main className="sedlex-shell__main">{children}</main>
      <footer className="sedlex-shell__footer">
        <div className="sedlex-footer-links">
          <Link
            to="/about"
            className="sedlex-footer-brand"
            aria-label={`About ${brand.fullName}`}
          >
            <BrandLogo variant="symbol" decorative />
            <span>{brand.fullName}</span>
          </Link>
          <nav aria-label="Footer">
            <Link to="/about">About {brand.shortName}</Link>
            <Link to="/corpus">Browse corpus</Link>
            <Link to="/quality">Data quality</Link>
            <Link to="/coverage">Technical evaluation</Link>
          </nav>
        </div>
        <div className="sedlex-disclaimer">
          <ShieldCheck aria-hidden="true" />
          <span>
            <strong>Research corpus.</strong> Machine-derived structure, links and
            reconstructed versions are not authoritative law. Always consult the certified
            source Act.
          </span>
        </div>
      </footer>
    </div>
  );
};
